/* !
 * prodSearch.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const params = new URLSearchParams(location.search);

	// フォームチェックリセット
	const resetForm = () => {
		document.querySelector('.js-reset').addEventListener('click', (e) => {
			e.currentTarget.closest('form').querySelectorAll('input[type="checkbox"]').forEach(ele => {
				ele.checked = false;
			});
		});
	};

	// 検索項目表示
	const setSearchWords = () => {
		const sep = FUNCTIONS.va.isEnglish ? ', ' : '、';

		const use = [...document.querySelectorAll('input[name="p_purpose"]:checked')]
			.map(ele => ele.nextElementSibling.textContent)
			.join(sep);
		if (use) {
			document.querySelector('.prod-results-elements .js-use').textContent = use;
		}

		const segments = [...document.querySelectorAll('input[name="p_field"]:checked')]
			.map(ele => ele.nextElementSibling.textContent)
			.join(sep);
		if (segments) {
			document.querySelector('.prod-results-elements .js-segments').textContent = segments;
		}

		const keywords = [1, 2, 3, 4, 5]
			.map(i => params.get(`p_keywords_${i}`))
			.filter(Boolean)
		if (keywords) {
			document.querySelector('.prod-results-elements .js-keywords').textContent = keywords.join(sep);
			document.querySelector('.prod-search-keyword input').value = keywords.join(' ');
		}
	};

	// 表示件数切り替えリンクにパラメータを反映
	const setParam = () => {
		const newParams = new URLSearchParams();
		params.getAll('p_purpose').forEach(v => {
			newParams.append('p_purpose', v);
		});
		params.getAll('p_field').forEach(v => {
			newParams.append('p_field', v);
		});
		[1, 2, 3, 4, 5].forEach(i => {
			const key = `p_keywords_${i}`;
			const value = params.get(key);
			if (value) {
				newParams.append(key, value);
			}
		});

		document.querySelectorAll('.js-sort').forEach(ele => {
			ele.setAttribute('href', `${ele.getAttribute('href')}?${newParams}`);
		});
	};


	// 最近見た製品
	const setRecentItems = () => {
		let jsonURL = `/ajax${FUNCTIONS.va.isEnglish ? '/english' : ''}/product/search/recent/product.json`;
		let favoStorage = [];
		for (let i in localStorage) {
			if (i.indexOf(`dksRecentProdList${FUNCTIONS.va.isEnglish ? 'EN' : ''}-`) !== -1) { favoStorage.push(i); }
		}
		if (favoStorage.length) {
			const params = new URLSearchParams();
			favoStorage.forEach(ele => {
				params.append('p_product', FUNCTIONS.va.isEnglish ? ele.replace(/dksRecentProdListEN-/, '') : ele.replace(/dksRecentProdList-/, ''));
			});
			console.log(`${jsonURL}?${params}`);

			fetch(`${jsonURL}?${params}`).then(response => response.json()).then(data => {
				if (data.rt_bn_product_info.length) {
					let prodList = data.rt_bn_product_info;

					prodList.forEach(ele => {
						ele.datetime = localStorage.getItem(
							`dksRecentProdList${FUNCTIONS.va.isEnglish ? 'EN' : ''}-${FUNCTIONS.va.isEnglish ? ele.rt_cf_p_href.href.split('/')[4].replace(/\.html/, '') : ele.rt_cf_p_href.href.split('/')[3].replace(/\.html/, '')}`
						);
					});
					prodList.sort((x, y) => {
						let xDate = x['datetime'];
						let yDate = y['datetime'];
						if (xDate > yDate) return -1;
						if (xDate < yDate) return 1;
						return 0;
					});
					if (prodList.length > 5) {
						localStorage.removeItem(`dksRecentProdList${FUNCTIONS.va.isEnglish ? 'EN' : ''}-${recipeData[4]._key}`);
						prodList.pop();
					}

					let recentHTML = '';
					prodList.forEach(ele => {
						recentHTML += `<li><a href="${ele.rt_cf_p_href.href}" class="mod-link01"><span>${ele.rt_cf_p_name.content}</span><svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#arrow_right2"></use></svg></a></li>`;
					});
					document.querySelector('.prod-recently').innerHTML = recentHTML;
				} else {
					document.querySelector('.js-prodRecentWrap').remove();
				}
			});
		} else {
			document.querySelector('.js-prodRecentWrap').remove();
		}
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const prodSearchFUNCTIONS = () => {
		resetForm();

		if (FUNCTIONS.va.pathname.indexOf('/results') !== -1) {
			setSearchWords();
			setParam();
		}

		setRecentItems();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { prodSearchFUNCTIONS(); }) : prodSearchFUNCTIONS();

})(window.FUNCTIONS);
